import { Component, OnInit, SimpleChanges } from '@angular/core';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { Form, FormGroup, FormControl, FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { KInputType} from 'ng-k-form';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { AsbestosisOutlineExposureService } from 'src/app/services/asbestosis-outline-exposure.service'
import { KListItem, KUtilsService as Utils } from 'ng-k-utils';
import { ClaimsService } from 'src/app/services/claims.service';
import { IkTableData, KTableGridService } from 'ng-k-data-visualization';
import { HttpClient } from '@angular/common/http';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';

const moment = require("moment");

@Component({
  selector: 'app-outline-exposure-to-dust',
  templateUrl: './outline-exposure-to-dust.component.html',
  styleUrls: ['./outline-exposure-to-dust.component.scss']
})
export class OutlineExposureToDustComponent implements OnInit {
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public formGroup!: FormGroup;
  public options:KListItem[] = [];
  public dynamicValue: any;
  public inputType: string | undefined;
  public inputTypes: {label: string, value: any}[] = [];
  public taskList: {label: string, value: any}[] = [];
  public fibreTypes: {label: string, value: any}[]= [];
  public rangeList: {label: string, value: any}[] = [];
  public daysList: {label: string, value: any}[] = [];
  public distanceCorrectionList: {label: string, value: any}[] = [];
  public claimId: any;
  public taskId: any;
  public employmentListData = [];
  public saveActivitiesData = [];
  public tasksListData = [];
  public currentEmployerData = [];
  public labelTooltip = 'Tooltip';
  public labelHelperText = 'Helper text';
  public dynamicDateInput: any = '';
  public dynamicNumberInput: any = '';

  public addActivityForm: any =  {};
  public isSubmitted = false;
  public tableData!: IkTableData;
  public data: any = [];
  public customData: any;

  showStage1: boolean = true;
  hideStage2: boolean = true; 
  hideStage3: boolean = true;
  hideStage4: boolean = true;

  public maxSize = 8;
  public sampleData = [];
  public currentActivityId: any = '';
  public comboboxHideNoData = false;
  public successText!: string;
  public errorText!: string;
  public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public timeout!: number;
  constructor(
    private route: ActivatedRoute,
    private loaderService: GlobalLoadingService,
    private asbestosisOutlineExposureService: AsbestosisOutlineExposureService,
    private fb: FormBuilder,
    private claimsService: ClaimsService,
    private _auth: OauthPlusService,
    public kTableGridService: KTableGridService,
    private http: HttpClient,
    private router: Router
  ) {
    this.addActivityForm = fb.group({
      employerName: ['',Validators.required],
      task: ['', [Validators.required, this.checkTaskInDropdown()]],
      fibreType: ['', Validators.required],
      dateFrom:['', [Validators.required, this.dateValidator()]],
      dateTo: ['', [Validators.required, this.dateValidator()]],
      mmExposed: ['', [Validators.required, Validators.min(1)]],
      distanceCorrection: ['', Validators.required],
      range: ['', Validators.required],
      days: ['', Validators.required]
    });
   }
   public dateValidator(): ValidatorFn {
    return (control:AbstractControl ): ValidationErrors | null  => {
      this.addActivityForm.controls?.dateFrom.setErrors( null );
      this.addActivityForm.controls?.dateTo.setErrors(null);

      if(this.addActivityForm.controls?.dateFrom.value && 
        this.addActivityForm.controls?.dateTo.value && 
          moment(this.addActivityForm.controls?.dateFrom.value).unix() >= moment(this.addActivityForm.controls?.dateTo.value).unix()){
        return { invalidDate: true };

      }
      return null;
    }
  }
  
   
  
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      //   console.log(params['taskId'])
      // console.log(params['claimId'])
      if (!this.isUrlEncoded(params['claimId'])) {
        this.claimId = decodeURIComponent(params['claimId']);
      } else {
        this.claimId = params['claimId'];
      }
  
      if (!this.isUrlEncoded(params['taskId'])) {
        this.taskId = decodeURIComponent(params['taskId']);
      } else {
        this.taskId = params['taskId'];
      }
  
      if (params['activityId']) {
        this.currentActivityId = params['activityId']
      }
        // this.claimId = decodeURIComponent(params['claimId']);
        // this.taskId = decodeURIComponent(params['taskId']);
        // console.log(this.taskId)
        // console.log(this.claimId)
        // console.log(this.currentActivityId)
      });
  
      
      this._auth.$whenUserLoaded.subscribe(data=> {
        if(data) {
          this.getEmploymentList(this.claimId);
          this.getTasksList();
          this.getFibreTypes();
          this.getDistanceCorrectionList();
          this.getRangeList();
          this.getDaysList();
  
          if (this.currentActivityId) {
            this.getExposureById()
          }
          this.getWorkflowOverview(this.claimId)
        }
      });
      this.dynamicDateInput = KInputType['datepicker'];
      this.dynamicNumberInput = KInputType['number'];
    }

    public getWorkflowOverview(claimID: any) {
      const thisObj = this;
      const requestParam: any = {};
      requestParam.claimId = claimID ? claimID : null;
      this.loaderService.startLoadingIndicator('getWorkflowOverview');
  
      thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('getWorkflowOverview');
          this.customData = {
            claimId : this.claimId,
            claimantName : result.data.meta.claimant.claimantName,
            medicalConditionLabel: 'Carcinoma of the Lung',
            medicalConditionValue: 'carcinoma-of-the-lung'
          }
        }
      },
      err => {
      });
    }

    checkTaskInDropdown():  ValidatorFn {
      return (control:AbstractControl ): ValidationErrors | null  => {
        const value = control.value;
        const currentTask = this.taskList.filter(task =>{
          return task.label === value
        })
        return  !currentTask.length ? { invalidTask: true } : null;
        }
      }    
  
    public getExposureById() {
        const thisObj = this;
        const requestParam: any = {};
        requestParam.claimId = this.claimId? this.claimId : null;
        requestParam.taskId = this.taskId? this.taskId : null;
        requestParam.actionName = 'exposure_item_by_id';
        requestParam.payload = {
          "id":this.currentActivityId
        };
        this.loaderService.startLoadingIndicator('getExposureById');
        thisObj.asbestosisOutlineExposureService.getActivityList(requestParam).subscribe(result => {
          if (result.status === 'Success') {
            this.loaderService.stopLoadingIndicator('getExposureById');
            this.hideStage2 = false;
            // console.log(result.data[0].task);
            this.currentEmployerData = result.data[0].employer;
            // console.log(this.currentEmployerData);
            this.addActivityForm.patchValue({
              employerName : result.data[0].employer.employer,
              task: result.data[0].task,
              fibreType: result.data[0].fiber,
              dateFrom: new Date(result.data[0].startDate),
              dateTo: new Date(result.data[0].endDate),
              mmExposed: result.data[0].exposedMm,
              distanceCorrection: result.data[0].distanceCorrection,
              range: result.data[0].range,
              days: result.data[0].days
            });
          }
        });
    }
  
    public isUrlEncoded(str: string): boolean {
      try {
        return str !== decodeURIComponent(str);
      } catch (e) {
        return false;
      }
    }
  
    public saveAddActivityForm(form: any) {
      this.isSubmitted = true;
      if(form.status == 'VALID'){
        const thisObj = this;
        const requestParam: any = {};
        this.loaderService.startLoadingIndicator('saveAddActivityForm');
        requestParam.claimId = this.claimId? this.claimId : null;
        requestParam.taskId = this.taskId? this.taskId : null;
        // console.log(this.currentActivityId);
        if (this.currentActivityId != '')
        {
          requestParam.actionName = 'edit_exposure';
          requestParam.payload = {
            "id" : this.currentActivityId,
            "employer" : this.currentEmployerData,
            "task": form.controls.task.value,
            "fiber": form.controls.fibreType.value,
            "startDate": form.controls.dateFrom.value,
            "endDate": form.controls.dateTo.value,
            "exposedMm": form.controls.mmExposed.value,
            "distanceCorrection": form.controls.distanceCorrection.value,
            "range": form.controls.range.value,
            "days": form.controls.days.value
          }
        } else {
          requestParam.actionName = 'add_exposure';
          requestParam.payload = {
            "employer" : this.currentEmployerData,
            "task": form.controls.task.value,
            "fiber": form.controls.fibreType.value,
            "startDate": form.controls.dateFrom.value,
            "endDate": form.controls.dateTo.value,
            "exposedMm": form.controls.mmExposed.value,
            "distanceCorrection": form.controls.distanceCorrection.value,
            "range": form.controls.range.value,
            "days": form.controls.days.value
          };
        }
        const startDate = (new Date(requestParam.payload.startDate)).toLocaleDateString("en-US").split('T')[0];
        const endDate = (new Date(requestParam.payload.endDate)).toLocaleDateString("en-US").split('T')[0];
        requestParam.payload.startDate = startDate;
        requestParam.payload.endDate = endDate;
        thisObj.claimsService.postWorkflowActivity(requestParam).subscribe(result => {
          if (result.status === 'Success') {
            this.loaderService.stopLoadingIndicator('saveAddActivityForm');
            if (result.data.isValid) {
              if (this.currentActivityId != '')
              { 
                this.successText = 'Activity edited successfully';
              } else {
                this.successText = 'Activity added successfully';
              }
              this.showMessage('success', 2000);
              setTimeout(() => {
                this.router.navigate(['carcinoma-of-the-lung/exposure/outline-exposure-to-dust/',this.claimId,this.taskId])
              },2020);
              this.getWorkflowFulfill(this.claimId)
            }
             else {
              this.errorText = result.data.errors;
              this.showMessage('error', 2000);
            }          
          }
        }); 
      }
    }
  
    public getWorkflowFulfill(claimId: any) {
      const thisObj = this;
      const requestParam: any = {};
      requestParam.claimId = claimId? claimId : null;
      this.loaderService.startLoadingIndicator('getWorkflowFulfill');
      thisObj.claimsService.getWorkflowFulfill(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('getWorkflowFulfill');
          // console.log('success : fetched getWorkflowFulfill');
          // this.router.navigate(['/claimDetail/',(this.claimId)]);
        }
      }); 
    }
  
    public getEmploymentList(claimId: any) {
      const thisObj = this;
      const requestParam: any = {};
      requestParam.claimId = claimId? claimId : null;
      this.loaderService.startLoadingIndicator('getEmploymentList');
      
      thisObj.asbestosisOutlineExposureService.getEmploymentList(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('getEmploymentList');
          this.employmentListData = result.data;
        }  
      },
      err => {
        console.log('err')
        console.log(err.error);
        this.loaderService.stopLoadingIndicator('getEmploymentList');
      }); 
    }
  
    public onEmployerNameClick(employer: any) {
      if(employer) {
        this.currentEmployerData = employer;
        this.hideStage2 = false;
      }
    }
  
    onDynamicChange() {
      if (this.inputType === 'combobox') {
        this.dynamicValue = 2;
      }
    }
  
    public getIndustryList() {
      let tempList = ['a','b','c','d'];
      for(let temp of tempList) {
        this.inputTypes.push({label: temp, value: temp });
        this.inputType = 'dropdown';
      }
    }
  
    public getTasksList() {
      const thisObj = this;
      const requestParam: any = {};
      this.loaderService.startLoadingIndicator('getTasksList');
      
      thisObj.asbestosisOutlineExposureService.getTaskstList(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('getTasksList');
          this.tasksListData = result.data;
          let tList = []
          for(let temp of result.data.rows) {
            tList.push({label: temp.task, value: temp.task });
            this.inputType = 'dropdown';
          }
          this.taskList = tList;
        }  
      },
      err => {
        console.log('err')
        console.log(err.error);
        this.loaderService.stopLoadingIndicator('getTasksList');
      }); 
    }
  
    public getFibreTypes() {
      let tempList = ['Amosite','Chrysotile','Crocidolite'];
      for(let temp of tempList) {
        this.fibreTypes.push({label: temp, value: temp });
        this.inputType = 'dropdown';
      }
    }
  
    public getDistanceCorrectionList() {
      let tempList = ['None','10`','20`'];
      for(let temp of tempList) {
        this.distanceCorrectionList.push({label: temp, value: temp });
        this.inputType = 'dropdown';
      }
    }
  
    public getRangeList() {
      let tempList = ['Low','Median','High'];
      for(let temp of tempList) {
        this.rangeList.push({label: temp, value: temp });
        this.inputType = 'dropdown';
      }
    }
  
    public getDaysList() {
      let tempList = ['1','2','3','4','5'];
      for(let temp of tempList) {
        this.daysList.push({label: temp, value: temp });
        this.inputType = 'dropdown';
      }
    }
  
    /**
     * convenience getter for easy access to form fields
     */
    get f() { 
      return this.addActivityForm.controls; 
    }
  
    public addNewActivity() {
      // console.log(this.currentActivityId);
      this.currentActivityId = '';
      this.addActivityForm.reset();
      this.isSubmitted = false;
      this.showStage1 = false;
      this.hideStage2 = false;
      this.hideStage4 = true;
    }
  
    editEmployer() {
      this.router.navigate(['claimForm',encodeURIComponent(this.claimId)]);
    }
  
    public showMessage(msgType: any, timeout: any) {
      this.displaySuccess = false;
      this.displaySuccess = false;
      if ( msgType === 'success' ) {
        this.displaySuccess = true;
      }
      if ( msgType === 'error') {
        this.displayError = true;
      }
      if ( timeout ) {
        this.timeout = timeout;
      }
    }
  
    goToPage() {
      this.router.navigate(['/carcinoma-of-the-lung/exposure/outline-exposure-to-dust/',this.claimId, this.taskId]);
    }
  }



